const differenceI18n = {
  "fr": {
    "difference": {
      "title": "Ce qui fait la différence",
      "p1": {
        "s1": "Nous rachetons vos ",
        "bold1": "écrans cassés",
        "s2": " et pièces inutilisées au",
        "bold2": " meilleur prix du marché",
        "s3": ", avec un processus simple, rapide et totalement",
        "bold3": " transparent",
        "s4": "."
      },
      "p2": {
        "s1": "Chez ",
        "bold1": "123Back",
        "s2": ", chaque pièce a de la valeur, vous ",
        "bold2": "encaissez",
        "s3": " sans délai tout en",
        "bold3": " libérant de la place",
        "s4": " dans vos ateliers."
      },
      "p3": {
        "bold1": "Notre service",
        "s2": " est pensé aussi bien pour les ",
        "bold2": "réparateurs indépendants",
        "s3": " que pour les",
        "bold3": " revendeurs",
        "s4": ", afin de vous offrir une ",
        "bold4": "solution fiable",
        "s5": " qui allie ",
        "bold5": "rentabilité immédiate",
        "s6": " et engagement ",
        "bold6": "écoresponsable",
        "s7": "."
      },
      "cards": {
        "prix": {
          "title": "Meilleur prix du marché",
          "desc": "Vos écrans et pièces détachées valorisés au tarif le plus juste.",
          "alt": "Poignée de main représentant un accord sur le prix"
        },
        "process": {
          "title": "Processus simple & rapide",
          "desc": "Estimez, envoyez, encaissez ! Tout se fait en quelques clics.",
          "alt": "Préparation d’un colis/emballage sécurisé"
        },
        "nature": {
          "title": "Engagement écoresponsable",
          "desc": "Donnez une seconde vie aux pièces, réduisez les déchets électroniques.",
          "alt": "Forêt symbolisant l’écoresponsabilité"
        }
      }
    }
  },
  "en": {
    "difference": {
      "title": "What makes the difference",
      "p1": {
        "s1": "We buy your ",
        "bold1": "broken screens",
        "s2": " and unused parts at the",
        "bold2": " best market price",
        "s3": ", with a process that’s simple, fast and fully",
        "bold3": " transparent",
        "s4": "."
      },
      "p2": {
        "s1": "At ",
        "bold1": "123Back",
        "s2": ", every part has value, you ",
        "bold2": "get paid",
        "s3": " without delay while",
        "bold3": " freeing up space",
        "s4": " in your workshops."
      },
      "p3": {
        "bold1": "Our service",
        "s2": " is designed for both ",
        "bold2": "independent repairers",
        "s3": " and",
        "bold3": " resellers",
        "s4": ", to offer you a ",
        "bold4": "reliable solution",
        "s5": " combining ",
        "bold5": "immediate profitability",
        "s6": " and an ",
        "bold6": "eco-responsible",
        "s7": " commitment."
      },
      "cards": {
        "prix": {
          "title": "Best market price",
          "desc": "Your screens and spare parts valued at the fairest rate.",
          "alt": "Handshake representing an agreement on price"
        },
        "process": {
          "title": "Simple & fast process",
          "desc": "Estimate, ship, get paid! All in just a few clicks.",
          "alt": "Preparing a parcel/secure packaging"
        },
        "nature": {
          "title": "Eco-responsible commitment",
          "desc": "Give parts a second life and reduce electronic waste.",
          "alt": "Forest symbolizing eco-responsibility"
        }
      }
    }
  },
  "pl": {
    "difference": {
      "title": "Co nas wyróżnia",
      "p1": {
        "s1": "Skupujemy Twoje ",
        "bold1": "pęknięte ekrany",
        "s2": " i nieużywane części w",
        "bold2": " najlepszej cenie na rynku",
        "s3": ", w procesie prostym, szybkim i w pełni",
        "bold3": " przejrzystym",
        "s4": "."
      },
      "p2": {
        "s1": "W ",
        "bold1": "123Back",
        "s2": " każda część ma wartość, ",
        "bold2": "pieniądze otrzymujesz",
        "s3": " bez zwłoki, jednocześnie",
        "bold3": " zwalniając miejsce",
        "s4": " w Twoim warsztacie."
      },
      "p3": {
        "bold1": "Nasza usługa",
        "s2": " jest przeznaczona zarówno dla ",
        "bold2": "niezależnych serwisantów",
        "s3": " jak i",
        "bold3": " sprzedawców",
        "s4": ", aby zaoferować Ci ",
        "bold4": "niezawodne rozwiązanie",
        "s5": " łączące ",
        "bold5": "natychmiastową opłacalność",
        "s6": " oraz ",
        "bold6": "odpowiedzialność ekologiczną",
        "s7": "."
      },
      "cards": {
        "prix": {
          "title": "Najlepsza cena na rynku",
          "desc": "Twoje ekrany i części wycenione w najuczciwszy sposób.",
          "alt": "Uścisk dłoni symbolizujący porozumienie cenowe"
        },
        "process": {
          "title": "Prosty i szybki proces",
          "desc": "Oszacuj, wyślij, odbierz płatność! Wszystko w kilka kliknięć.",
          "alt": "Przygotowanie paczki/bezpieczne pakowanie"
        },
        "nature": {
          "title": "Odpowiedzialność ekologiczna",
          "desc": "Daj częściom drugie życie i ogranicz elektroodpady.",
          "alt": "Las symbolizujący odpowiedzialność ekologiczną"
        }
      }
    }
  },
  "es": {
    "difference": {
      "title": "Lo que marca la diferencia",
      "p1": {
        "s1": "Compramos tus ",
        "bold1": "pantallas rotas",
        "s2": " y piezas no utilizadas al",
        "bold2": " mejor precio del mercado",
        "s3": ", con un proceso simple, rápido y totalmente",
        "bold3": " transparente",
        "s4": "."
      },
      "p2": {
        "s1": "En ",
        "bold1": "123Back",
        "s2": ", cada pieza tiene valor, ",
        "bold2": "cobras",
        "s3": " sin demora mientras",
        "bold3": " liberas espacio",
        "s4": " en tu taller."
      },
      "p3": {
        "bold1": "Nuestro servicio",
        "s2": " está diseñado tanto para ",
        "bold2": "técnicos independientes",
        "s3": " como para",
        "bold3": " revendedores",
        "s4": ", con el objetivo de ofrecerte una ",
        "bold4": "solución fiable",
        "s5": " que combina ",
        "bold5": "rentabilidad inmediata",
        "s6": " y un compromiso ",
        "bold6": "eco-responsable",
        "s7": "."
      },
      "cards": {
        "prix": {
          "title": "Mejor precio del mercado",
          "desc": "Tus pantallas y piezas valoradas al precio más justo.",
          "alt": "Apretón de manos representando un acuerdo sobre el precio"
        },
        "process": {
          "title": "Proceso simple y rápido",
          "desc": "¡Estima, envía y cobra! Todo se hace en pocos clics.",
          "alt": "Preparación de un paquete / embalaje seguro"
        },
        "nature": {
          "title": "Compromiso eco-responsable",
          "desc": "Da una segunda vida a las piezas y reduce los residuos electrónicos.",
          "alt": "Bosque simbolizando la eco-responsabilidad"
        }
      }
    }
  },
  "it": {
    "difference": {
      "title": "Cosa fa la differenza",
      "p1": {
        "s1": "Compriamo il tuo",
        "bold1": "schermi rotti",
        "s2": "e parti inutilizzate al",
        "bold2": "migliore prezzo di mercato",
        "s3": ", con un processo semplice, veloce e completamente",
        "bold3": "trasparente",
        "s4": "."
      },
      "p2": {
        "s1": "A",
        "bold1": "123Back",
        "s2": "ogni parte ha valore, tu",
        "bold2": "ottenere pagato",
        "s3": "senza indugio mentre",
        "bold3": "liberare spazio",
        "s4": "nei vostri laboratori."
      },
      "p3": {
        "bold1": "Il nostro servizio",
        "s2": "è progettato per entrambi",
        "bold2": "riparatori indipendenti",
        "s3": "e",
        "bold3": "rivenditori",
        "s4": ", per offrirvi un",
        "bold4": "soluzione affidabile",
        "s5": "combinazione",
        "bold5": "redditività immediata",
        "s6": "e una",
        "bold6": "eco-responsabile",
        "s7": "impegno."
      },
      "cards": {
        "prix": {
          "title": "Miglior prezzo di mercato",
          "desc": "I vostri schermi e pezzi di ricambio valutati al tasso più giusto.",
          "alt": "Handshake che rappresenta un accordo sul prezzo"
        },
        "process": {
          "title": "Processo semplice e veloce",
          "desc": "Stima, nave, vieni pagato! Tutto in pochi clic.",
          "alt": "Preparazione di un pacco / imballaggio sicuro"
        },
        "nature": {
          "title": "Impegno responsabile ecologico",
          "desc": "Dare parti una seconda vita e ridurre i rifiuti elettronici.",
          "alt": "Foresta simbolo dell'ecoresponsabilità"
        }
      }
    }
  },
  "de": {
    "difference": {
      "title": "Was macht den Unterschied",
      "p1": {
        "s1": "Wir kaufen Ihre",
        "bold1": "Gebrochene Bildschirme",
        "s2": "und unbenutzte Teile am",
        "bold2": "Bester Marktpreis",
        "s3": "mit einem Prozess, der einfach, schnell und vollständig ist",
        "bold3": "transparent",
        "s4": "."
      },
      "p2": {
        "s1": "im",
        "bold1": "123Back",
        "s2": "Jeder Teil hat Wert, du",
        "bold2": "bezahlt",
        "s3": "ohne Verzögerung",
        "bold3": "Freigeben von Raum",
        "s4": "in Ihren Workshops."
      },
      "p3": {
        "bold1": "Unser Service",
        "s2": "ist für beide konzipiert",
        "bold2": "unabhängige Reparaturbetriebe",
        "s3": "und",
        "bold3": "Wiederverkäufer",
        "s4": "um Ihnen eine",
        "bold4": "zuverlässige Lösung",
        "s5": "Kombination",
        "bold5": "Sofortige Rentabilität",
        "s6": "und ein",
        "bold6": "umweltverantwortlich",
        "s7": "Verpflichtung."
      },
      "cards": {
        "prix": {
          "title": "Bester Marktpreis",
          "desc": "Ihre Bildschirme und Ersatzteile zum fairsten Preis bewertet.",
          "alt": "Handshake repräsentiert eine Preisvereinbarung"
        },
        "process": {
          "title": "Einfacher und schneller Prozess",
          "desc": "Schätzung, Schiff, bezahlt! Alles in nur wenigen Klicks.",
          "alt": "Vorbereitung eines Pakets/sicherer Verpackung"
        },
        "nature": {
          "title": "Umweltverantwortliches Engagement",
          "desc": "Geben Sie Teilen ein zweites Leben und reduzieren Sie elektronischen Abfall.",
          "alt": "Wald symbolisiert Umweltverantwortung"
        }
      }
    }
  },
  "pt": {
    "difference": {
      "title": "O que faz a diferença",
      "p1": {
        "s1": "Compramos o teu",
        "bold1": "ecrãs quebrados",
        "s2": "e peças não utilizadas na",
        "bold2": "melhor preço de mercado",
        "s3": ", com um processo simples, rápido e completo",
        "bold3": "transparente",
        "s4": "."
      },
      "p2": {
        "s1": "Em",
        "bold1": "123Back",
        "s2": ", cada parte tem valor, você",
        "bold2": "ser pago",
        "s3": "sem demora enquanto",
        "bold3": "libertando espaço",
        "s4": "nas suas oficinas."
      },
      "p3": {
        "bold1": "Nosso serviço",
        "s2": "é projetado para ambos",
        "bold2": "reparações independentes",
        "s3": "e",
        "bold3": "revendedores",
        "s4": ", para oferecer-lhe um",
        "bold4": "solução fiável",
        "s5": "associação",
        "bold5": "rendibilidade imediata",
        "s6": "e um",
        "bold6": "eco-responsável",
        "s7": "compromisso."
      },
      "cards": {
        "prix": {
          "title": "Melhor preço de mercado",
          "desc": "Suas ecrãs e peças de reposição avaliadas à taxa mais justa.",
          "alt": "Aperto de mão representando um acordo sobre o preço"
        },
        "process": {
          "title": "Processo simples e rápido",
          "desc": "Estimativa, nave, ser pago! Tudo em apenas alguns cliques.",
          "alt": "Preparação de uma encomenda/acondicionamento seguro"
        },
        "nature": {
          "title": "Compromisso eco-responsável",
          "desc": "Dar às partes uma segunda vida e reduzir o desperdício eletrônico.",
          "alt": "Floresta simbolizando eco-responsabilidade"
        }
      }
    }
  },
  "cs": {
    "difference": {
      "title": "Jaký je v tom rozdíl?",
      "p1": {
        "s1": "Koupíme si váš",
        "bold1": "rozbité obrazovky",
        "s2": "a nepoužité části na",
        "bold2": "nejlepší tržní cena",
        "s3": ", s procesem, který je jednoduchý, rychlý a plně",
        "bold3": "transparentní",
        "s4": "."
      },
      "p2": {
        "s1": "V",
        "bold1": "123Back",
        "s2": "Každá část má hodnotu.",
        "bold2": "dostat zaplaceno",
        "s3": "neprodleně",
        "bold3": "uvolňování prostoru",
        "s4": "ve vašich workshopech."
      },
      "p3": {
        "bold1": "Naše služba",
        "s2": "je určen pro oba",
        "bold2": "nezávislé opravny",
        "s3": "a",
        "bold3": "Prodejny",
        "s4": ", nabídnout vám",
        "bold4": "spolehlivé řešení",
        "s5": "kombinovat",
        "bold5": "okamžitá ziskovost",
        "s6": "a",
        "bold6": "odpovědnost",
        "s7": "závazek."
      },
      "cards": {
        "prix": {
          "title": "Nejlepší tržní cena",
          "desc": "Vaše obrazovky a náhradní díly jsou ceněny tou nejlepší rychlostí.",
          "alt": "Potřesení rukou představující dohodu o ceně"
        },
        "process": {
          "title": "Jednoduchý a rychlý proces",
          "desc": "Odhad, loď, dostat zaplaceno! Jen pár kliknutí.",
          "alt": "Příprava balíku / zabezpečeného obalu"
        },
        "nature": {
          "title": "Eko-odpovědný závazek",
          "desc": "Dejte součástkám druhý život a omezte elektronický odpad.",
          "alt": "Les symbolizující ekologickou odpovědnost"
        }
      }
    }
  },
  "nl": {
    "difference": {
      "title": "Wat maakt het verschil",
      "p1": {
        "s1": "Wij kopen uw",
        "bold1": "gebroken schermen",
        "s2": "en ongebruikte onderdelen op de",
        "bold2": "beste marktprijs",
        "s3": ", met een proces dat eenvoudig, snel en volledig",
        "bold3": "transparant",
        "s4": "."
      },
      "p2": {
        "s1": "Bij",
        "bold1": "123Back",
        "s2": ", elk deel heeft waarde, jij",
        "bold2": "betaald krijgen",
        "s3": "zonder vertraging, zolang",
        "bold3": "ruimte vrijmaken",
        "s4": "in uw werkplaatsen."
      },
      "p3": {
        "bold1": "Onze service",
        "s2": "is ontworpen voor beide",
        "bold2": "onafhankelijke reparateurs",
        "s3": "en",
        "bold3": "wederverkopers",
        "s4": ", om u een",
        "bold4": "betrouwbare oplossing",
        "s5": "combineren",
        "bold5": "onmiddellijke winstgevendheid",
        "s6": "en een",
        "bold6": "eco-verantwoordelijk",
        "s7": "inzet."
      },
      "cards": {
        "prix": {
          "title": "Beste marktprijs",
          "desc": "Uw schermen en reserveonderdelen gewaardeerd tegen het juiste tarief.",
          "alt": "Handdruk die een prijsovereenkomst vertegenwoordigt"
        },
        "process": {
          "title": "Eenvoudig & snel proces",
          "desc": "Schatting, schip, word betaald! Alles in een paar klikken.",
          "alt": "Voorbereiding van een pakket/veilige verpakking"
        },
        "nature": {
          "title": "Milieuverantwoordelijke inzet",
          "desc": "Geef onderdelen een tweede levensduur en verminder elektronisch afval.",
          "alt": "Bos symboliseert milieuverantwoordelijkheid"
        }
      }
    }
  }
};

export default differenceI18n;
